import React from 'react';

import { AdaptiveCarouselImage, Hidden, Visible } from '@vp/swan';

import { Image } from '../domain/Image';
import { useResponsiveCloudinaryImage } from '../libs/useResponsiveCloudinaryImage';

import { ZoomedImage } from './zoom/ZoomedImage';

export interface GalleryImageProps {
  image: Image;
  zoomContainerId?: string;
  alt: string;
}

export const GalleryImage: React.FC<GalleryImageProps> = (props) => {
  const { src, srcSet } = useResponsiveCloudinaryImage(props.image.gallery);

  return (
    <>
      <Visible xs sm>
        <AdaptiveCarouselImage
          aspectRatio="1"
          objectFit="contain"
          id="gallery-main"
          src={src}
          srcSet={srcSet}
          alt={props.alt}
        />
      </Visible>

      <Hidden xs sm>
        {!props.zoomContainerId ? (
          <AdaptiveCarouselImage
            id="gallery-main"
            src={src}
            srcSet={srcSet}
            alt={props.alt}
            objectFit="contain"
            aspectRatio="1"
          />
        ) : (
          <ZoomedImage
            src={src}
            srcSet={srcSet}
            image={props.image}
            zoomContainerId={props.zoomContainerId!}
            alt={props.alt}
          />
        )}
      </Hidden>
    </>
  );
};
